import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IoArrowBackSharp } from "react-icons/io5";
import { useIntl, FormattedMessage } from "react-intl";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SortingRule } from "react-table";
import { Col, Row } from "reactstrap";
import { Parameter } from "../../models/Parameter";
import { KpiService } from "../../services/KpiService";
import { CreateAssistanceDTO } from "../../models/Assistance/CreateAssistanceDTO";
import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import Layout from "../../components/Layout/Layout";
import TableComponent from "../../components/TableComponent";
import MultiSelectComponent from "../../components/MultiSelectComponent";
import { SelectItemsProps } from "../../components/SearchSelectComponent";
import SelectComponent from "../../components/SelectComponent";
import Toast from "../../helpers/Toast";
import { Utilities } from "../../helpers/Utilities";
import { AssistanceService } from "../../services/AssistanceService";
import { AssistancesWithExecutionNotFinishedDTO } from "../../models/Kpi/AssistancesWithExecutionNotFinishedDTO";
import { FcViewDetails } from "react-icons/fc";

export default function KpiAssistancesExecutionNotFinished() {
    const intl = useIntl();
    const navigate = useNavigate();
    const assistanceService = new AssistanceService();
    const kpiService = new KpiService();
    const pageSizes: number[] = [5, 15, 30];
    
    const [data, setData] = useState<AssistancesWithExecutionNotFinishedDTO[]>([]);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const [goToPage, setGoToPage] = useState<number>();
    const [initialSortBy] = useState<SortingRule<object>[]>(Utilities.LoadSortParametersFromURLQuery("sortField", "sortOrder"));

    const [searchParams] = useSearchParams();
    const [page] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [pageSize] = useState<number>(Utilities.LoadPageSizeFromURLQuery(pageSizes));
    const [currentPage, setCurrentPage] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [currentPageSize, setCurrentPageSize] = useState<number>();
    const [currentSorting, setCurrentSorting] = useState<SortingRule<object>[] | null>(null);

    const [status, setStatus] = useState<string>(Utilities.LoadParameterFromURLQuery("status", "string", ""));
    const [numDoc, setNumDoc] = useState<string>(Utilities.LoadParameterFromURLQuery("numDoc", "number", ""));
    const [initialDate, setInitialDate] = useState<string>(Utilities.LoadParameterFromURLQuery("initialDate", "string", ""));
    const [endDate, setEndDate] = useState<string>(Utilities.LoadParameterFromURLQuery("endDate", "string", ""));
    const [selectedTechnician, setSelectedTechnician] = useState<string>(Utilities.LoadParameterFromURLQuery("technician", "string", ""));
    const [technicians, setTechnicians] = useState<SelectItemsProps[]>([]);
    const [reloadSearch, setReloadSearch] = useState<boolean>(false);
    const [isButtonCreateLoading, setIsButtonCreateLoading] = useState<boolean>(false);

    const [listStatus, setListStatus] = useState<SelectItemsProps[]>([]);
    
    const columns = React.useMemo(
        () => [
            {
                Header: "",
                accessor: " ",
                Cell: (props: any) => {
            
                    return (
                        <div style={{ display: "flex" }}>
                            <Tooltip title="Ver Detalhes" aria-label="Ver Detalhes" enterNextDelay={500} enterDelay={500}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        const documentId = props.cell.row.original.documentId;
                                        const [erpDocType, erpSerie, erpNumber] = documentId.split(" ");
                                        const projectErpId = documentId.project?.erpId || null;
                                        const equipmentErpId = documentId.equipment?.erpId || null;
                                        const equipmentSerialNumber = documentId.equipment?.serialNumber || null;
                                        const equipmentBrand = documentId.equipment?.brand || null
                                        const equipmentModel = documentId.equipment?.model || null;
                                        const clientErpId = documentId.client?.erpId || null;
                                        const docNumber = erpNumber || null;
                                        const docType = erpDocType || null;
                                        const docSerie = erpSerie || null;
                                        const budgetSellingPrice = documentId.budgetSellingPrice || null;
                                        const budgetCostPrice = documentId.budgetCostPrice || null;
                                        createAssistance(projectErpId, equipmentErpId, equipmentSerialNumber, equipmentBrand, equipmentModel, clientErpId,
                                            docNumber, docType, docSerie, budgetSellingPrice, budgetCostPrice
                                        );
                                    }}
                                >
                                    <FcViewDetails className="icons" />
                                </div>
                            </Tooltip>
                        </div>
                    );
                },
                width: 5,
            },
            {
                Header: <FormattedMessage id="Screens.Kpi.AssistancesExecutionNotFinished.Table.DocumentId" />,
                accessor: "documentId",
                width: 15,
            },
            {
                Header: <FormattedMessage id="Screens.Kpi.AssistancesExecutionNotFinished.Table.Date" />,
                accessor: "assistanceDate",
                width: 20,
                Cell: (props: any) => <span>{Utilities.formatDate(new Date(props.cell.value))}</span>,
            },
            {
                Header: <FormattedMessage id="Screens.Kpi.AssistancesExecutionNotFinished.Table.Status" />,
                accessor: "status",
                width: 15,
            },
            {
                Header: <FormattedMessage id="Screens.Kpi.AssistancesExecutionNotFinished.Table.Technician" />,
                accessor: "technicianName",
                width: 15,
            },
            {
                Header: <FormattedMessage id="Screens.Kpi.AssistancesExecutionNotFinished.Table.Start" />,
                accessor: "executionStart",
                width: 20,
                Cell: (props: any) => {
                    const date = new Date(props.cell.value);
                    return <span>{Utilities.formatDate(date)} {date.toLocaleTimeString()}</span>;
                }
            },
            {
                Header: <FormattedMessage id="Screens.Kpi.AssistancesExecutionNotFinished.Table.End" />,
                accessor: "executionEnd",
                width: 20,
                Cell: (props: any) => {
                    if (props.cell.value) {
                        const date = new Date(props.cell.value);
                        return <span>{Utilities.formatDate(date)} {date.toLocaleTimeString()}</span>;
                    }
                    return <span>-</span>;
                }
            },
        ],
        []
    );

    const getStatus = async () => {
        var response = await assistanceService.GetStatus();
        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        var items: SelectItemsProps[] = [];
        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.enumValue,
                label: element.name,
            };
            items.push(item);
        });

        setListStatus(items);
    };

    const getTechnicians = async () => {
        const list: SelectItemsProps[] = [];
        var response = await assistanceService.GetWorkshopTechniciansWithCode();

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.id,
                label: element.name,
            };
            list.push(item);
        });

        setTechnicians(list);
    };

    const goBack = () => {
        navigate("/kpis");
    };

    const createAssistance = async (projectErpId: string | null, equipmentErpId: string, equipmentNumSerie: string, equipmentBrand: string, equipmentModel: string, clientErpId: string, numDoc: number, typeDoc: string, serie: string, budgetSellingPrice: number, budgetCostPrice: number) => {
        var sendData: CreateAssistanceDTO = {
            equipmentErpId: equipmentErpId,
            equipmentNumSerie: equipmentNumSerie,
            equipmentBrand: equipmentBrand,
            equipmentModel: equipmentModel,
            projectErpId: projectErpId,
            clientErpId: clientErpId,
            numDoc: numDoc,
            typeDoc: typeDoc,
            serie: serie,
            id: 0,
            date: new Date(),
            description: null,
            notes: null,
            clientId: null,
            counter1: 0,
            counter2: 0,
            counter3: 0,
            assistanceType: null,
            stockEntryDocumentErpId: null,
            budgetSellingPrice: budgetSellingPrice,
            budgetCostPrice: budgetCostPrice
        };

        setIsButtonCreateLoading(true);
        var response = await assistanceService.Create(sendData);
        setIsButtonCreateLoading(false);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        navigate(`/Backoffice/Assistance/${response.obj}`);
    };

    const fetchData = async (
        page: number,
        pageSize: number,
        sortBy: SortingRule<object>[] | null
    ) => {
        var searchUrl: string = `?page=${page}&pageSize=${pageSize}` +
            `${Utilities.AddParamToQueryIfValue("numDoc", "number", numDoc)}` +
            `${Utilities.AddParamToQueryIfValue("technician", "string", selectedTechnician)}` +
            `${Utilities.AddParamToQueryIfValue("status", "string", status)}`+
            `${Utilities.AddParamToQueryIfValue("initialDate", "string", initialDate)}` +
            `${Utilities.AddParamToQueryIfValue("endDate", "string", endDate)}`;

        if (sortBy != null && sortBy.length > 0) {
            searchUrl += `${Utilities.AddParamToQueryIfValue(
                "sortField",
                "string",
                sortBy[0].id
            )}${Utilities.AddParamToQueryIfValue(
                "sortOrder",
                "string",
                sortBy[0].desc === true ? "DESC" : "ASC"
            )}`;
        }

        //Se antes não existirem parâmetros de pesquisa, significa que o user veio para aqui de uma rota, então para não ficar com duas rotas duplicadas, fazemos replace à rota
        
        if (searchParams.toString() === "") {
            navigate(`/kpis/AssistancesExecutionNotFinished${searchUrl}`, { replace: true });
        } else {
            //Se já existirem parâmetros de pesquisa, não fazemos replace mas push
            navigate(`/kpis/AssistancesExecutionNotFinished${searchUrl}`);
        }

        setLoading(true);

        var response = await kpiService.GetAssistancesWithExecutionNotFinished(
            mountSearchParameters(),
            Utilities.MountSortParameters(sortBy),
            page,
            pageSize
        );

        if (response.success !== true) {
            setData([]);
            setPageCount(0);
            setLoading(false);
            setCurrentPageSize(5);
            setCurrentPage(1);
            setCurrentSorting(null);
            Toast.Show("error", response.message);
            return;
        }

        if (response.items.length === 0) {
            setCurrentPage(1);
            setGoToPage(1);
            Toast.Show("info", "Não existe nenhuma assistência com esses dados");
        }

        setData(response.items);
        setPageCount(response.totalPages);
        setLoading(false);
        setCurrentPageSize(pageSize);
        setCurrentPage(page);
        setCurrentSorting(sortBy);
        setGoToPage(0);

        if (response.totalPages > 0 && page > response.totalPages) {
            setGoToPage(1);
        }
    };

    const mountSearchParameters = (): Parameter[] => {
        var parameters: Parameter[] = [];
        parameters.push(new Parameter("numDoc", numDoc));
        parameters.push(new Parameter("technicianName", selectedTechnician));
        parameters.push(new Parameter("status", status));
        parameters.push(new Parameter("initialDate", initialDate));
        parameters.push(new Parameter("endDate", endDate));

        return parameters;
    };

    const onEnter = () => {
        fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
    };
    const onButtonClick = async () => {
        setCurrentPage(1);
        setGoToPage(1);
        fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
    };
    const onRemoveFiltersClick = async () => {
        setCurrentPage(1);
        setGoToPage(1);
        setStatus("");
        setSelectedTechnician("");
        setNumDoc("");
        setInitialDate("");
        setEndDate("");
        setReloadSearch(true);
    };

    useEffect(() => {
        if (reloadSearch === true) {
            fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
            setReloadSearch(false);
        }
        return () => { };
    }, [reloadSearch]);

    useEffect(() => {
        getStatus();
        getTechnicians();
    }, []);

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        <Col style={{ margin: "0px", padding: "0px" }}>
                            <span className="pageTitle"> <IoArrowBackSharp className="pageTitleBackIcon" onClick={goBack} /> <FormattedMessage id="Screens.Kpi.AssistancesExecutionNotFinished.Title" />:
                            </span>
                        </Col>
                    </Row>
                </div>
                <div className="pageBody">
                        <Row>
                        <InputComponent
                            xl={1}
                            lg={2}
                            md={5}
                            sm={6}
                            xs={12}
                            style={{ width: "100%", height: "43px" }}
                            type={"number"}
                            label={intl.formatMessage({ id: "Screens.Kpi.AssistancesExecutionNotFinished.Filters.NumDoc" })}
                            readOnly={false}
                            value={numDoc}  
                            onEnter={onEnter}
                            onChange={(t: string) => setNumDoc(t)}
                        />

                        <MultiSelectComponent
                            xl={2}
                            lg={2}
                            md={3}
                            sm={6}
                            xs={12}
                            label={intl.formatMessage({ id: "Screens.Kpi.AssistancesExecutionNotFinished.Filters.Status" })}
                            items={listStatus}
                            setSelectedString={setStatus}
                            selectString={status}
                        />

                        <SelectComponent
                            xl={2}
                            lg={2}
                            md={5}
                            sm={6}
                            xs={12}
                            style={{ width: "100%", height: "43px" }}
                            label={intl.formatMessage({
                                id: "Screens.Kpi.AssistancesExecutionNotFinished.Filters.TechnicianName",
                            })}
                            selectedItemValue={selectedTechnician}
                            items={technicians}
                            onChange={(t: string) => setSelectedTechnician(t)}
                        />

                        <InputComponent
                            xl={2}
                            lg={2}
                            md={2}
                            sm={2}
                            xs={2}
                            style={{ width: "100%" }}
                            type={"date"}
                            onEnter={onEnter}
                            value={initialDate}
                            label={intl.formatMessage({ id: "Screens.Kpi.AssistancesExecutionNotFinished.Filters.InitialDate" })}
                            readOnly={false}
                            onChange={(t: string) => setInitialDate(t)}
                        />

                        <InputComponent
                            xl={2}
                            lg={2}
                            md={2}
                            sm={2}
                            xs={2}
                            style={{ width: "100%" }}
                            type={"date"}
                            onEnter={onEnter}
                            value={endDate}
                            label={intl.formatMessage({ id: "Screens.Kpi.AssistancesExecutionNotFinished.Filters.FinalDate" })}
                            readOnly={false}
                            onChange={(t: string) => setEndDate(t)}
                        />
                    </Row>

                    <Row>
                        <Col
                            xl={6}
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            style={{ marginTop: "1em", display: "inline-flex", gap: "1rem" }}>
                            <ButtonComponent
                                text={intl.formatMessage({ id: "Common.Buttons.Search" })}
                                onClick={onButtonClick}
                            />
                            <ButtonComponent
                                text={intl.formatMessage({ id: "Common.Buttons.RemoveFilters" })}
                                onClick={onRemoveFiltersClick}
                            />
                        </Col>
                    </Row>
                        <TableComponent
                        goToPage={goToPage}
                        loading={loading}
                        pageCount={pageCount}
                        columns={columns}
                        manualPagination={true}
                        fetchData={fetchData}
                        pageSizes={pageSizes}
                        initialPage={page}
                        initialPageSize={pageSize}
                        initialSortBy={initialSortBy}
                        data={data}
                        dontOrderFirstCollumn={true}
                    />
                </div>
            </div>
        </Layout>
    );
}